import MutedText from 'components/common/MutedText';
import { HubertButton } from 'components/HubertUI/HubertButton';
import HubertCollapsible from 'components/HubertUI/HubertCollapsible';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import type { TIntent } from '@hubertai/screening-question-types';
import { useQuestionEditorContext } from '../../../context/create-question.context';
import Intent from './Intent';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import {
  selectQuestionInTemplateEditAndUneditable,
  selectQuestionIsReadonly,
  selectQuestionLanguage,
} from 'rtk/questionEditorSelector';
import { addIntent } from 'rtk/Question.Editor.Slice';
import { useTranslation } from 'react-i18next';

const UpsertIntentsContainer = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const intents = useAppSelector((state) => state.questionEditor.byId[questionId].intents);
  const inTemplateEditAndUneditable = useAppSelector((state) =>
    selectQuestionInTemplateEditAndUneditable(state, questionId),
  );
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));
  const [open, setOpen] = useState(true);

  if (isReadOnly) {
    return null;
  }

  return (
    <HubertCollapsible className={`p-1`} open={open} onOpenChange={setOpen}>
      <div className="mb-1 flex flex-row items-center justify-between">
        <HubertCollapsible.Trigger className="flex cursor-pointer flex-row items-center gap-2">
          <ChevronDown
            size={16}
            className={`cursor-pointer transition-transform duration-200 ${open ? 'rotate-180' : 'rotate-0'}`}
          />
          <HubertLabel className="cursor-pointer">
            {t('intents.label')}
            <MutedText className="cursor-pointer" text={` - ${t('intents.description')}`} />
          </HubertLabel>
        </HubertCollapsible.Trigger>

        <HubertButton
          size="sm"
          disabled={inTemplateEditAndUneditable}
          onClick={() => {
            dispatch(addIntent({ questionId, language: questionLanguage, intent: '' }));
          }}
        >
          {t('intents.addIntent')}
        </HubertButton>
      </div>

      <HubertCollapsible.Content>
        {intents!.map((intent: TIntent, index: number) => {
          return <Intent key={`intent-${intent.intent}-${index}`} intent={intent} intentIndex={index} />;
        })}
      </HubertCollapsible.Content>
    </HubertCollapsible>
  );
};

export default UpsertIntentsContainer;
